import { IItemDetailLine } from "./interface";
import { ContainerIconLabel, Icon, Label } from "./styles";

export const ItemDetailLine = ({
  disabled,
  onClick,
  icon,
  label,
  permissions,
  hidden,
}: IItemDetailLine) => {
  if (hidden || !permissions) return null;

  return (
    <ContainerIconLabel disabled={disabled}>
      <Icon>{icon}</Icon>
      <Label
        onClick={() => {
          if (!disabled) onClick();
        }}
        disabled={disabled}
      >
        {label}
      </Label>
    </ContainerIconLabel>
  );
};
